module.exports = __webpack_public_path__ + "img/@logo_kbfg@3x.a8d736fd.png";